<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      @if(srDetailLoader){
      <app-skeleton-loader
        [formLoader]="true"
        [noOfFields]="5"
      ></app-skeleton-loader>
      } @if(!srDetailLoader){
      <form [formGroup]="form">
        @if (step >= 1) {
        <!-- Notes -->
        @if (srNumber && srInprgoressAwating && !srDetailLoader) {
        <app-validation-message
          type="info"
          [content]="{
            title: 'SECTION_NOTES' | translate,
            message: 'SECTION_NOTES_DESCRIPTION' | translate
          }"
          [showbutton]="false"
          [buttonText]="'VIEW_NOTES' | translate"
          (onBtnClick)="showNotes = true"
        />
        }
        <section>
          <h1 class="section-heading">
            {{
              (isTrainingWorkshop
                ? "MRM_AWARDS.TITLE_MRM_WORKSHOP"
                : "MRM_AWARDS.TITLE"
              ) | translate
            }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-text-field
                [label]="'MRM_AWARDS.MEMBERSHIP_NUMBER' | translate"
                [control]="form.get('membershipNumber')!"
              />
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'MRM_AWARDS.MEMBER_NAME_AR' | translate"
                [control]="form.get('memberNameAr')!"
                [maxlength]="150"
              />
            </div>
            <div class="field-control">
              <app-text-field
                [label]="'MRM_AWARDS.MEMBER_NAME_EN' | translate"
                [control]="form.get('memberNameEn')!"
                [maxlength]="150"
              />
            </div>
            @if(isTrainingWorkshop){
            <div class="field-control">
              <app-option-field
                [label]="'MRM_AWARDS.NO_OF_DELEGATES' | translate"
                [control]="form.get('delegates')!"
                [options]="[{ Value: 1 }, { Value: 2 }]"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
                (onSelectionChange)="getUnitPrice($event)"
              />
            </div>

            <div class="field-control">
              <app-text-field
                [type]="'number'"
                [label]="'MRM_AWARDS.UNIT_PRICE' | translate"
                [control]="form.get('unitPrice')!"
              />
            </div>
            }
          </div>
        </section>
        }
        <!-- End request detail -->

        @if (step >= 2) {
        <section class="space-y-4">
          <h1 class="section-heading">
            {{ "DOCUMENTS.TITLE" | translate }}
          </h1>
          <div class="px-2 hidden">
            <p [innerHTML]="'DOCUMENT_NOTE' | translate"></p>
          </div>
          <div class="fields-container">
            @if(loadingDoc){
            <app-skeleton-loader
              [formLoader]="true"
              [noOfFields]="3"
            ></app-skeleton-loader>
            } @if (srFolder && !loadingDoc) { @for (dt of
            srFolder.allowedDocumentTypes; track $index) {
            <div class="field-control">
              <app-file
                #fileCmp
                [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                [control]=""
                [documentType]="dt.nameEn"
                (folderMissing)="openFolder()"
                (onUploadRemove)="(false)"
                [showAction]="showActions"
                [folder]="srFolder"
                [documentServiceType]="documentServiceType.PS"
              ></app-file>
            </div>
            } }
          </div>
        </section>
        }
        <!-- End documents -->

        @if (step >= 3) {
        <section>
          <h1 class="section-heading">
            {{ "SECTION_PAYMENT_METHOD" | translate }}
          </h1>
          <div class="fields-container">
            <div class="field-control">
              <app-boolean
                [label]="'PAYMENT_METHOD' | translate"
                [control]="form.get('paymentMethod')!"
                [lovType]="lookupKey.PAYMENT_METHOD"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
                (onSelectionChange)="onPaymentMethodChange($event)"
              />
            </div>
            @if ( noAdvancePaymentBalance) {
            <app-validation-message
              [content]="{
                title: 'ALERT.ERROR' | translate,
                message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
              }"
              type="error"
            />
            }
          </div>
        </section>
        }
        <div class="fields-container">
          @if(technicalErrorMsg || errorMsg){
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: errorMsg
                ? errorMsg
                : ('TOAST_MESSAGES.TECHNICAL_ERROR' | translate)
            }"
            [showbutton]="false"
          ></app-validation-message>
          }

          <div class="btn-section buttons-group">
            @if(!formSubmitLoader && showActions){
            <app-button
              classesName="btn-edge-cut btn-width-auto"
              [label]="'BUTTONS.NEXT' | translate"
              (onBtnClick)="nextStep()"
            />
            <app-button
              classesName="card-edge-cut-white btn-width-auto"
              [label]="'BUTTONS.SAVE_CLOSE' | translate"
              (onBtnClick)="saveAndClose()"
            />
            } @if(formSubmitLoader){
            <app-button
              type="button"
              classesName="btn-edge-cut btn-width-auto"
              [label]="'PLEASE_WAIT' | translate"
              [disabled]="true"
            ></app-button>
            }
          </div>
        </div>
      </form>
      }
    </div>
  </div>
</div>

<div>
  <app-service-progress
    [serviceName]="
      (isTrainingWorkshop
        ? 'MRM_AWARDS.PROGRESS_LABEL_WORKSHOP'
        : 'MRM_AWARDS.PROGRESS_LABEL'
      ) | translate
    "
    [completePercentage]="formProgress"
  />
</div>

@if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
}

<!-- Pending SR Number -->

@if (pendingSrNumber) {
<app-pending-sr-modal
  [srNumber]="pendingSrNumber"
  (onClose)="closependingSrModal()"
/>
}


<!-- notes modal -->
@if(showNotes) {
<app-notes
  [srNumber]="srNumber"
  [allowSubmit]="true"
  (onClose)="showNotes = false"
></app-notes>
}
